export const useSnackbar = () => {
  const snackbarRef = ref(null);

  const triggerSnackbar = (message, timeout, offset) => {
    snackbarRef.value.showSnackbar(message, timeout, offset);
  };

  return {
    snackbarRef,
    triggerSnackbar,
  }
}